import { frontendURL } from '../../../helper/URLHelper';
import AiBotSettings from './pages/AiBotSettings.vue';
import Companies from './pages/Companies.vue';
import CompanyManage from './pages/CompanyManage.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/ai-companies'),
    name: 'ai_companies_dashboard_index',
    component: Companies,
    meta: {
      permissions: ['administrator'],
    },
  },
  {
    path: frontendURL(
      'accounts/:accountId/ai-companies/:companyId'
    ),
    name: 'ai_company_manage',
    component: CompanyManage,
    meta: {
      permissions: ['administrator'],
    },
  },
  {
    path: frontendURL('accounts/:accountId/ai-bot'),
    name: 'ai_bot_settings',
    component: AiBotSettings,
    meta: {
      permissions: ['administrator'],
    },
  },
];
